<template>
    <div>
        <div class='pag-header mb-2 p-1'>
            <h3 class="text-right text-white mr-3">OBRAS</h3>
        </div>

        <l-map :zoom="zoom" :center="center">
            <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
            <v-marker-cluster :options="clusterOptions" ref="cluster">
            <l-marker v-for="item in markers" :key="item.id" ref="mks" :id="item.id" :lat-lng="item.latlng" @l-add="$event.target.openPopup()">
            <l-popup>
                <div class='text-center'><h6>{{item.objeto}}</h6><br><div class='text-left mb-1' style='color: #777;'>SITUAÇÃO DA OBRA</div><div style='width: 100%; padding:5px;border-radius: 5px;color: #777;' class='bg-success text-white'>{{item.descricao}}</div><br><div class='container'><div class='row text-center'><div class='col-10 col-sm-6' style='max-width: 100%;color: #777;'>INÍCIO <br><span style='color: #255595; font-size: 1rem;'>{{item.dtInicio}}</span></div><div class='col-10 col-sm-6' style='color: #777;'>CONCLUSÃO <br><span style='color:#255595; font-size: 1rem;'>{{item.dtConclusao}}</span></div></div></div><br><router-link :to="{ name: 'detalheObra', params: { id: item.id}}" class='btn btn-sm btn-primary text-white'>Saiba Mais</router-link></div>
            </l-popup>
        </l-marker>
        </v-marker-cluster>
        </l-map>

        <section id="search-form" class="pesquisar">
            <div class="container">

                <form id="form-search" class="ts-form">
                    <section class="ts-box p-0">
                        <div class="form-row px-4 py-3">
                            <div class="col-sm-12 col-md-4">
                                <select class="custom-select my-2" id="areas" @change="filtrarMarcadores()" v-model="carea">
                                    <option value="" selected="true">Áreas</option>
                                    <option v-for="(item, i) in area" :key="i" :value="item.c03_id">
                                        {{item.c03_descr}}
                                    </option>
                                </select>
                            </div>

                            <div class="col-md-8">
                                <div class="form-row">
                                    <div class="col-sm-6">
                                        <select class="custom-select my-2" id="type" @change="filtrarMarcadores()" v-model="ctipoObra">
                                            <option value="" selected="true">Tipo de Obra</option>
                                            <option v-for="(item, i) in tipoObra" :key="i" :value="item.c01_id">
                                                {{item.c01_descr}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-6">
                                        <select class="custom-select my-2" id="status" @change="filtrarMarcadores()" v-model="cstatus">
                                            <option value="" selected="true">Status</option>
                                            <option v-for="(item, i) in status" :key="i" :value="item.c04_id">
                                                {{item.c04_descr}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </section>
                </form>
            </div>
        </section>
        <div class="container">
            <h3 class="mb-4 mt-4 text-center">Confira todas as Obras da cidade de Ibiúna:</h3>
            <div>
                <div id="grid-obras" style="width:100%; height:310px; background-color:white;"></div>
                <div id="pagingbox"></div>
                <div id="recInfoArea"></div>
            </div>
        </div>
        <div class="obras-fundo container-fluid mt-4 mb-4 p-5">
            <div class="row">
                <div class="col-10 col-sm-5 text-justify text-white">
                    <h5>O Portal de Obras de Ibiúna tem como objetivo prover aos cidadãos as informações e andamento de obras da cidade.</h5>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


    import {
        LMap,
        LTileLayer,
        LMarker,
        LPolyline,
        LLayerGroup,
        LTooltip,
        LPopup,
        LControlZoom,
        LControlAttribution,
        LControlScale,
        LControlLayers
    } from "vue2-leaflet";
    import {mapState} from "vuex"
    import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster/dist/Vue2LeafletMarkercluster'

    const axios = require('axios');

    function rand(n) {
        let max = n + 0.1
        let min = n - 0.1
        return Math.random() * (max - min) + min;
    }

    export default {
        name: 'Obras',
        components: {
            LMap,
            LTileLayer,
            LMarker,
            LPolyline,
            LLayerGroup,
            LTooltip,
            LPopup,
            LControlZoom,
            LControlAttribution,
            LControlScale,
            LControlLayers,
            'v-marker-cluster': Vue2LeafletMarkercluster
        },
        computed: mapState(['api']
        ),
        data() {
            return {
                dados: '',
                obras: '',
                zoom: 12,
                center: L.latLng(-23.6601, -47.2235),
                url: 'https://{s}.tile.osm.org/{z}/{x}/{y}.png',
                attribution: '&copy; OpenStreetMap Lliege Obras',
                markers: [],
                area: '',
                tipoObra: '',
                status: '',
                carea: '',
                ctipoObra: '',
                cstatus: '',
                clusterOptions: {},
                gridObras: '',
            }
        },
        methods: {
            filtrarMarcadores(){
                axios
                    .post(this.api+'obras-cidadao/obras', {
                        o01_tpobra_id: this.ctipoObra,
                        o01_area_id: this.carea,
                        o01_situacao_id: this.cstatus,
                    })
                    .then(response => {
                        this.markers = [];
                        this.preencheMarcadores(response.data);

                        this.gridObras.filterBy(22, this.ctipoObra)
                        this.gridObras.filterBy(21, this.carea, true)
                        this.gridObras.filterBy(24, this.cstatus, true)
                    });
            },
            preencheMarcadores(marcadores){
                for (var i = 0; i < marcadores.length; i++) {
                    this.obras = marcadores;
                    var lati = marcadores[i].o01_latitude;
                    var longi = marcadores[i].o01_longitude;
                    if (L.latLng(lati, longi) == null) continue;

                    this.markers.push({
                        id: marcadores[i].o01_id,
                        latlng: L.latLng(lati, longi),
                        objeto: marcadores[i].o01_objeto,
                        descricao: marcadores[i].situacao.c04_descr,
                        dtInicio: marcadores[i].o01_dt_inicio,
                        dtConclusao: marcadores[i].o01_dt_conclusao
                    });
                }
            },

        },

        created() {
            axios
                .get(this.api+"obras-cidadao/obras")
                .then(response => {
                    this.preencheMarcadores(response.data);
                })

        },
        mounted() {
            let thisVue = this;

            setTimeout(() => {
                this.$nextTick(() =>{
                this.clusterOptions = { disableClusteringAtZoom: 11 }
                });
            }, 5000),

            axios
                .get(this.api+'obras-cidadao/tipo-obras').then(response => {
                    this.tipoObra = response.data;

            });

            axios
                .get(this.api+'obras-cidadao/situacoes').then(response => {
                this.status = response.data;
            });

            axios
                .get(this.api+'obras-cidadao/areas').then(response => {
                this.area = response.data;
            });

            axios
                .get(this.api+'obras-cidadao/obras/dhtmlx')
                .then(response => {
                    this.dados = response.data;
                    this.gridObras.parse(this.dados, "json");
                })

            this.gridObras = new dhtmlXGridObject('grid-obras');
            this.gridObras.setImagePath("libs/imgs/");
            this.gridObras.setHeader("Código, Número, Objeto,Descrição, Bairro, data inicio, data previsao entrega,data conclusao, fiscal,bairro,bairro,Bairro, Endereço, a,a,a,a,a,a,a,a,a,a,a,a,a");
            this.gridObras.setInitWidths("*,*,440,440,120,120,120,120,120,120,120,220,*,*,*,*,*,*,*,*,*,*,*,*,*,*");
            this.gridObras.setColAlign("left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left,left");
            this.gridObras.setColTypes("ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro,ro");
            // gridObras.setColSorting("int,int,str");
            this.gridObras.attachHeader("&nbsp;,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter,#text_filter");
            this.gridObras.setSkin('web');
            this.gridObras.setStyle("background-color:#666;color:white; font-weight:bold;", "","color:red;", "");
            this.gridObras.init();
            this.gridObras.setColumnHidden(0, true);
            this.gridObras.setColumnHidden(2, true);
            this.gridObras.setColumnHidden(4, true);
            this.gridObras.setColumnHidden(5, true);
            this.gridObras.setColumnHidden(6, true);
            this.gridObras.setColumnHidden(7, true);
            this.gridObras.setColumnHidden(8, true);
            this.gridObras.setColumnHidden(9, true);
            this.gridObras.setColumnHidden(10, true);
            this.gridObras.setColumnHidden(13, true);
            this.gridObras.setColumnHidden(14, true);
            this.gridObras.setColumnHidden(15, true);
            this.gridObras.setColumnHidden(16, true);
            this.gridObras.setColumnHidden(17, true);
            this.gridObras.setColumnHidden(18, true);
            this.gridObras.setColumnHidden(19, true);
            this.gridObras.setColumnHidden(20, true);
            this.gridObras.setColumnHidden(21, true);
            this.gridObras.setColumnHidden(22, true);
            this.gridObras.setColumnHidden(23, true);
            this.gridObras.setColumnHidden(24, true);
            this.gridObras.setColumnHidden(25, true);
            this.gridObras.enablePaging(true, 10, 5, "pagingbox", true, "recInfoArea");
            this.gridObras.attachEvent("onRowSelect", function(id,ind){
                let mks = thisVue.$refs.mks;
                let entrei = false;
                mks.forEach(function (mk) {
                    if(mk.$el.id == id){
                        entrei = true;
                        let m = mk.mapObject;
                        thisVue.$refs.cluster.mapObject.zoomToShowLayer(m, function() {
                            $('html, body').animate({
                                scrollTop: $(".pag-header").offset().top
                            }, 100);
                            m.openPopup();
                        });
                    }
                });

                if(!entrei){
                    swal("Atenção!", "Não foram encontradas coordenadas válidas para esta obra", "error");
                }
            });

        }

    }
</script>
<style scoped>
    .vue2leaflet-map {
        position: none;
        height: 400px !important;
        width: 100%;
        margin-bottom: 10px;
    }

    .pag-header {
        height: 40px;
        width: 100%;
        background-image: url('/static/img/pag-header.png');
    }

    .obras-fundo {
        height: 200px;
        background-color: #918255;
    }

    .pesquisar {
        margin-top: -18px;
        background-color: #EBEBEB;
    }

    #recInfoArea, #pagingbox {
        color: #464646;
    }

</style>





// WEBPACK FOOTER //
// src/components/pagina-obras/Obras.vue